import animals from './animals';
import comments from './comments';
import posts from './posts';
import subscriptions from './subscriptions';
import push from './push';
import likes from './likes';

export default {
  namespaced: true,
  modules: {
    animals,
    comments,
    posts,
    push,
    subscriptions,
    likes,
  },
};
